import { z } from 'zod';

import { semverSchema, slugSchema } from '../common/primitives';

/**
 * Der Teil des Blueprint-Begriffs, den **beide** Seiten sehen.
 *
 * Bewusst nur die Referenz, nicht das Manifest. Das Manifest beschreibt, wie
 * aus einem Website-Typ eine Spezifikation entsteht — das ist Master-Wissen und
 * liegt in `@kraaapf/blueprints`. Der Worker bekommt nie ein Manifest, sondern
 * ausschließlich die fertig gerenderte `SiteSpec`.
 *
 * Diese Grenze ist der Grund, warum ein neuer Website-Typ den Agent nicht
 * anfasst: Er kennt Blueprints nur als zwei Zeichenketten in seinem Protokoll.
 */

/** Versionierte Referenz auf einen Katalog-Eintrag, z. B. `static-nginx@1.0.0`. */
export const blueprintReferenceSchema = z.object({
  key: slugSchema,
  version: semverSchema,
});

export type BlueprintReference = z.infer<typeof blueprintReferenceSchema>;

/** Formatiert eine Referenz für Logs und Fehlermeldungen: `static-nginx@1.0.0`. */
export function formatBlueprintReference(reference: BlueprintReference): string {
  return `${reference.key}@${reference.version}`;
}
